import { AxiosError } from 'axios'

import { client } from './client'
import * as ENDPOINTS from './endpoints'

export interface LoginData extends JSON {
  email: string
  password: string
}

interface LoginResponseType {
  detail: string
}

export interface LoginResultType {
  result: boolean
  errorCode?: string
}

export const login = async (data: LoginData): Promise<LoginResultType> => {
  try {
    data.email = data.email.toLowerCase()
    const response = await client.post<LoginResponseType, LoginData>(ENDPOINTS.LOGIN, data)
    if (response.status === 200) {
      return { result: true }
    } else {
      return { result: false }
    }
  } catch (error) {
    if (error instanceof AxiosError && error.response) {
      if (error.response.status === 403) {
        const detail = (error.response.data as LoginResponseType | undefined)?.detail
        return { result: false, errorCode: detail }
      }
      if (error.response.status === 400) {
        return { result: false }
      }
      if (error.response.status === 401) {
        return { result: false }
      }
    }
    return { result: false }
  }
}
